export default __webpack_public_path__ + "static/media/98.c779aca7.gif";